import { createRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { rootRoute } from '@/routes/root'

import { ResetPassword } from './resetPassword'

const resetPasswordRouteSchema = z.object({
  customer_id: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  user_id: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  digest: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  expiry: z
    .number()
    .nullish()
    .transform((data) => data ?? undefined),
})

export const resetPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/reset-password',
  component: ResetPassword,
  validateSearch: resetPasswordRouteSchema,
})

export type ResetPasswordRouteSearchParams = z.infer<typeof resetPasswordRouteSchema>
